<template>
  <v-btn icon @click="exportToExcel">
    <v-icon>mdi-table-large</v-icon>
  </v-btn>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Vue from "vue";

export default {
  methods: {
    async exportToExcel() {
      try {
        let token = await Vue.prototype.$auth.getUserToken();
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/integration/reg`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data.data.data;

        if (Array.isArray(data)) {
          const ws = XLSX.utils.json_to_sheet(data);

          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

          const currentDate = new Date();
          const formattedDate = `${currentDate.getDate()}_${
            currentDate.getMonth() + 1
          }_${currentDate.getFullYear()}`;

          const fileName = `relatorio_${formattedDate}.xlsx`;

          XLSX.writeFile(wb, fileName);
        } else {
          console.error(
            "Erro ao exportar para Excel: A resposta não contém um array de dados"
          );
        }
      } catch (error) {
        console.error("Erro ao exportar para Excel:", error);
      }
    },
  },
};
</script>
